import palette from "assets/theme/base/palette";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Doughnut } from "react-chartjs-2";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Breadcrumbs from "examples/Breadcrumbs";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import * as ChartUtils from "utils";
import logo from "assets/images/maxu-gray.png";
import { call } from "services/axiosService/core";
import ContentPlayerDialog from "examples/Dialog/ContentPlayerDialog";
import ShareContentDialog from "examples/Dialog/ShareContentDialog";
import { useMaterialUIController } from "context";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Chart } from "chart.js";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Loader from "pages/loader/Loader";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Antelope from "assets/images/insights/antelope.png";
import Bear from "assets/images/insights/bear.png";
import Beaver from "assets/images/insights/beaver.png";
import Bee from "assets/images/insights/bee.png";
import Bobcat from "assets/images/insights/bobcat.png";
import Buffalo from "assets/images/insights/buffalo.png";
import Cat from "assets/images/insights/cat.png";
import Chameleon from "assets/images/insights/chameleon.png";
import Cheetah from "assets/images/insights/cheetah.png";
import Deer from "assets/images/insights/deer.png";
import Dolphin from "assets/images/insights/dolphin.png";
import Eagle from "assets/images/insights/eagle.png";
import Elephant from "assets/images/insights/elephant.png";
import Fox from "assets/images/insights/fox.png";
import GermanShepherd from "assets/images/insights/german-shepherd.png";
import Giraffe from "assets/images/insights/giraffe.png";
import GoldenRetriever from "assets/images/insights/golden-retriever.png";
import Hawk from "assets/images/insights/hawk.png";
import Kangaroo from "assets/images/insights/kangaroo.png";
import Koala from "assets/images/insights/koala.png";
import Leopard from "assets/images/insights/leopard.png";
import Lion from "assets/images/insights/lion.png";
import Meerkat from "assets/images/insights/meerkat.png";
import Moose from "assets/images/insights/moose.png";
import Mustang from "assets/images/insights/mustang.png";
import Orca from "assets/images/insights/orca.png";
import Otter from "assets/images/insights/otter.png";
import Owl from "assets/images/insights/owl.png";
import Panda from "assets/images/insights/panda.png";
import Panther from "assets/images/insights/panther.png";
import Peacock from "assets/images/insights/peacock.png";
import Penguin from "assets/images/insights/penguin.png";
import Puppy from "assets/images/insights/puppy.png";
import Rabbit from "assets/images/insights/rabbit.png";
import Rhino from "assets/images/insights/rhino.png";
import Shark from "assets/images/insights/shark.png";
import Sheep from "assets/images/insights/sheep.png";
import Squirrel from "assets/images/insights/squirrel.png";
import Tiger from "assets/images/insights/tiger.png";
import Turtle from "assets/images/insights/turtle.png";
import Wolf from "assets/images/insights/wolf.png";
import Zebra from "assets/images/insights/zebra.png";
import DefaultImage from "assets/images/insights/defaultInsight.png";
import MaxuLogo from "assets/images/nav-logo.png";
import * as Sentry from "@sentry/browser";
import { useTranslation } from "react-i18next";

const DATA_COUNT_INNER = 5;
const NUMBER_CFG_INNER = { count: DATA_COUNT_INNER, min: 100, max: 100 };
const DATA_COUNT_OUTER = 15;
const NUMBER_CFG_OUTER = { count: DATA_COUNT_OUTER, min: 100, max: 100 };

const Animals = {
  Antelope,
  Bear,
  Beaver,
  Bee,
  Bobcat,
  Buffalo,
  Cat,
  Chameleon,
  Cheetah,
  Deer,
  Dolphin,
  Eagle,
  Elephant,
  Fox,
  GermanShepherd,
  Giraffe,
  GoldenRetriever,
  Hawk,
  Kangaroo,
  Koala,
  Leopard,
  Lion,
  Meerkat,
  Moose,
  Mustang,
  Orca,
  Otter,
  Owl,
  Panda,
  Panther,
  Peacock,
  Penguin,
  Puppy,
  Rabbit,
  Rhino,
  Shark,
  Sheep,
  Squirrel,
  Tiger,
  Turtle,
  Wolf,
  Zebra,
};

const LEGEND_COLORS = [
  palette.chart.coral,
  palette.chart.amber,
  palette.chart.yellow,
  palette.chart.seafoam,
  palette.chart.sky,
];

const TILE_ICONS = ["track_changes", "event_note", "autorenew", "forum"];
const TILE_COLORS = ["#43a047", "#7b1fa2", "#1565c0", "#e65100"];
const TILE_BGS = ["#e8f5e9", "#f3e5f5", "#e3f2fd", "#fff3e0"];

export function Insight() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { profile, persona } = controller;
  const { id: assessment_id } = useParams();
  const { user_id: userId } = useParams();
  const [insight, setInsight] = useState(null);
  const [insightMessage, setInsightMessage] = useState(null);
  const [insightName, setInsightName] = useState();
  const matches = useMediaQuery("(max-width:420px)");
  const [insightScoreKey, setInsightScoreKey] = useState([]);
  const [insightScoreValue, setInsightScoreValue] = useState([]);
  const [insightScoreValueOuter, setInsightScoreValueOuter] = useState([]);
  const [insightBackground, setInsightBackground] = useState([]);
  const [animalName, setAnimalName] = useState(null);
  const [animalThumbnail, setAnimalThumbnail] = useState(null);
  const [showMoreInsightsButton, setShowMoreInsightsButton] = useState(true);
  const [insightSummary, setInsightSummary] = useState("");
  const [insightRecommendations, setInsightRecommendations] = useState([]);
  const [topContent, setTopContent] = useState([]);
  const [contentFilter, setContentFilter] = useState("allContentLinks");
  const [learnerName, setLearnerName] = useState("");
  const [loader, setLoader] = useState(true);
  const [insightsNotReady, setInsightsNotReady] = useState(false);
  const [content, setContent] = useState({});
  const [playContent, setPlayContent] = useState(false);
  const [userMetricsData, setUserMetricsData] = useState(null);
  const [likedContent, setLikedContent] = useState([]);
  const [dislikedContent, setDislikedContent] = useState([]);
  const [savedContent, setSavedContent] = useState([]);
  const [viewedContent, setViewedContent] = useState([]);
  const [shareContent, setShareContent] = useState(false);
  const [shareContentTitle, setShareContentTitle] = useState("");
  const [learnerMetricsData, setLearnerMetricData] = useState(null);
  const [assessmentType, setAssessmentType] = useState("NEO");
  const [hasGamePlan, setHasGamePlan] = useState(false);

  Chart.register(ChartDataLabels);
  let pieValue;
  const data = {
    labels: insightScoreKey,
    datasets: [
      {
        label: "Dataset Outer",
        scores: insightScoreValueOuter,
        data: ChartUtils.numbers(NUMBER_CFG_OUTER),
        backgroundColor: Object.values(ChartUtils.CHART_COLORS),
        borderWidth: 10,
        weight: matches ? 3 : 1,
        backgroundColor: [
          palette.chart.grey,
          palette.chart.coral,
          palette.chart.grey,
          palette.chart.amber,
          palette.chart.grey,
          palette.chart.grey,
          palette.chart.yellow,
          palette.chart.grey,
          palette.chart.grey,
          palette.chart.grey,
          palette.chart.grey,
          palette.chart.seafoam,
          palette.chart.sky,
          palette.chart.grey,
          palette.chart.grey,
        ],
        backgroundColor: insightBackground,
      },
      {
        label: "Dataset Inner",
        data: insightScoreValue,
        backgroundColor: Object.values(ChartUtils.CHART_COLORS),
        borderWidth: 10,
        weight: 5,
        backgroundColors: [
          palette.chart.coral,
          palette.chart.amber,
          palette.chart.yellow,
          palette.chart.seafoam,
          palette.chart.sky,
        ],
      },
    ],
  };

  const getRecommendationIcon = (text = "") => {
    const value = text.toLowerCase();

    // Visualization / imagination
    if (
      value.includes("visualization") ||
      value.includes("visualize") ||
      value.includes("imagine")
    ) {
      return "visibility";
    }

    // Meditation / mindfulness / calmness
    if (
      value.includes("meditation") ||
      value.includes("mindfulness") ||
      value.includes("deep breathing") ||
      value.includes("calm")
    ) {
      return "self_improvement";
    }

    // Reflection / self-awareness
    if (
      value.includes("self-reflection") ||
      value.includes("reflection") ||
      value.includes("reflect")
    ) {
      return "manage_search";
    }

    // New experiences / creativity / exploration
    if (
      value.includes("new experiences") ||
      value.includes("new things") ||
      value.includes("creative") ||
      value.includes("innovative") ||
      value.includes("explore")
    ) {
      return "explore";
    }

    // Goals / achievement
    if (value.includes("goal") || value.includes("achievement")) {
      return "flag";
    }

    // Routine / consistency / schedule
    if (value.includes("routine") || value.includes("schedule") || value.includes("consistent")) {
      return "calendar_month";
    }

    // Teamwork / community / relationships
    if (
      value.includes("teamwork") ||
      value.includes("team") ||
      value.includes("community") ||
      value.includes("relationships")
    ) {
      return "groups";
    }

    // Communication / conversations
    if (
      value.includes("communication") ||
      value.includes("conversation") ||
      value.includes("talking")
    ) {
      return "forum";
    }

    // Leadership
    if (value.includes("leadership") || value.includes("lead")) {
      return "workspace_premium";
    }

    // Coaching / guidance / feedback
    if (value.includes("feedback") || value.includes("coach") || value.includes("guidance")) {
      return "rate_review";
    }

    // Self-care / rest / recovery
    if (
      value.includes("self-care") ||
      value.includes("relax") ||
      value.includes("sleep") ||
      value.includes("rest")
    ) {
      return "spa";
    }

    // Training / workouts / practice
    if (value.includes("training") || value.includes("workout") || value.includes("practice")) {
      return "fitness_center";
    }

    // Competition / performance
    if (value.includes("competition") || value.includes("performance")) {
      return "emoji_events";
    }

    // Positive mindset / confidence
    if (value.includes("positive self-talk") || value.includes("confidence")) {
      return "sentiment_satisfied_alt";
    }

    // Growth / improvement
    if (value.includes("growth") || value.includes("improve") || value.includes("progress")) {
      return "trending_up";
    }

    // Challenges / pushing limits
    if (value.includes("challenge") || value.includes("comfort zone")) {
      return "bolt";
    }

    // Focus / concentration
    if (value.includes("focus") || value.includes("concentration")) {
      return "center_focus_strong";
    }

    // Technique / skills
    if (value.includes("technique") || value.includes("skills")) {
      return "sports";
    }

    // Time management / reminders
    if (value.includes("time") || value.includes("reminders") || value.includes("calendar")) {
      return "schedule";
    }

    // Tracking / analytics
    if (value.includes("track") || value.includes("data")) {
      return "insights";
    }

    return "lightbulb";
  };

  useEffect(() => {
    if (window.pendo) {
      window.pendo.track("View Insights Screen");
    }
  }, [window.pendo]);

  useEffect(() => {
    loadInsights();
    loadUserContentMetrics();
    loadLearnerContentMetrics();
    getUserGamePlan();
  }, []);

  // Scoring runs asynchronously after the last answer is submitted (a
  // DynamoDB Stream trigger, then a PAR API call), so insights can be
  // requested before the assessment has actually reached "ready" -- the
  // backend answers 400 with "Insights are not ready for this assessment
  // yet." in that case, not an error. Retry a few times with backoff before
  // giving up, instead of leaving the loader spinning forever (there was no
  // branch that ever cleared it for a non-200/non-440 response) or making
  // the user manually refresh the page to re-poll.
  const INSIGHTS_RETRY_DELAYS_MS = [3000, 5000, 8000, 8000, 8000];

  const loadInsights = (attempt = 0) => {
    if (userId && assessment_id) {
      setLoader(true);
      setInsightsNotReady(false);
      call(`users/${userId}/assessments/${assessment_id}/insights`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            setLoader(false);
            const resData = res.data;
            console.log("insights data", res.data);
            const type = resData?.assessment_type || "NEO";
            setInsight(resData.insights.insight_details);
            setAssessmentType(type);
            setTopContent(
              resData.insights.top_content.sort((a, b) =>
                parseFloat(a.weight) < parseFloat(b.weight) ? 1 : -1
              )
            );
            setAnimalName(resData.insights.animal);
            if (resData.insights.animal_url) {
              setAnimalThumbnail(resData.insights.animal_url);
            } else {
              setAnimalThumbnail(
                Animals[resData.insights.animal.split(" ").join("")] || DefaultImage
              );
            }
            setInsightSummary(resData.insights.summary);
            setLearnerName(resData.insights.learner_name);
            setInsightRecommendations(resData.insights.recommendations);
            const scores = Object.keys(resData.scores);
            setInsightScoreKey(scores);
            setInsightScoreValue([100, 100, 100, 100, 100]);
            if (type == "NEO") {
              const temp = [];
              Object.values(resData.scores).map((item) => {
                temp.push(item);
                temp.push(item);
                temp.push(item);
              });
              setInsightScoreValueOuter(temp);

              const background = [];
              const bgcolor = {};
              bgcolor[scores[0]] = palette.chart.coral;
              bgcolor[scores[1]] = palette.chart.amber;
              bgcolor[scores[2]] = palette.chart.yellow;
              bgcolor[scores[3]] = palette.chart.seafoam;
              bgcolor[scores[4]] = palette.chart.sky;

              var scoresObj = new Map(Object.entries(resData.scores));
              scoresObj.forEach((item, key) => {
                if (item < 45) {
                  background.push(bgcolor[key]);
                  background.push(palette.chart.grey);
                  background.push(palette.chart.grey);
                } else if (item < 56) {
                  background.push(palette.chart.grey);
                  background.push(bgcolor[key]);
                  background.push(palette.chart.grey);
                } else {
                  background.push(palette.chart.grey);
                  background.push(palette.chart.grey);
                  background.push(bgcolor[key]);
                }
              });
              setInsightBackground(background);
            }
          } else if (res.status == 440) {
            setLoader(false);
          } else if (attempt < INSIGHTS_RETRY_DELAYS_MS.length) {
            setTimeout(
              () => loadInsights(attempt + 1),
              INSIGHTS_RETRY_DELAYS_MS[attempt]
            );
          } else {
            setLoader(false);
            setInsightsNotReady(true);
          }
        })
        .catch((err) => {
          console.log(err);
          Sentry.captureException(err);
        });
    }
  };

  const getUserGamePlan = () => {
    call(`users/${profile.id}/gameplan`, "GET", {})
      .then((response) => {
        if (response.status === 200) {
          setHasGamePlan(true);
        } else if (response.status === 404) {
          setHasGamePlan(false);
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.log(error);
      });
  };

  const loadUserContentMetrics = () => {
    if (profile.id) {
      call(`users/${profile.id}/contentmetrics`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            let data = res.data;
            setUserMetricsData(data);
            setLikedContent([...data.likedcontent]);
            setDislikedContent([...data.dislikedcontent]);
            setViewedContent([...data.viewedcontent]);
            setSavedContent([...data.savedcontent]);
          } else if (res.status == 440) {
            setLoader(false);
          }
        })
        .catch((err) => {
          console.log(err);
          Sentry.captureException(err);
        });
    }
  };

  const loadLearnerContentMetrics = () => {
    if (userId) {
      call(`users/${userId}/contentmetrics`, "GET", {})
        .then((res) => {
          if (res.status == 200) {
            setLearnerMetricData(res.data);
          }
        })
        .catch((err) => {
          console.log(err);
          Sentry.captureException(err);
        });
    }
  };

  const pieSliceHAndler = (evt, activeEls, chart) => {
    if (!activeEls || activeEls.length === 0 || !activeEls[0]?.datasetIndex) {
      console.warn("No active elements or invalid structure", activeEls);
      return;
    }
    pieValue = chart.data.labels[activeEls[0].index];
    if (!pieValue) {
      console.warn("No valid pieValue for the active element", activeEls[0]);
      return;
    }
    if (pieValue === "Openness") {
      setInsightMessage(insight.Openness.messages);
      setContentFilter("Openness");
      setInsightName(t("insights.openness"));
    } else if (pieValue === "Conscientiousness") {
      setInsightMessage(insight.Conscientiousness.messages);
      setContentFilter("Conscientiousness");
      setInsightName(t("insights.conscientiousness"));
    } else if (pieValue === "Extraversion") {
      setInsightMessage(insight.Extraversion.messages);
      setContentFilter("Extraversion");
      setInsightName(t("insights.extraversion"));
    } else if (pieValue === "Agreeableness") {
      setInsightMessage(insight.Agreeableness.messages);
      setContentFilter("Agreeableness");
      setInsightName(t("insights.agreeableness"));
    } else if (pieValue === "Temperament") {
      setInsightMessage(insight.Temperament.messages);
      setContentFilter("Temperament");
      setInsightName(t("insights.temperament"));
    }
  };

  const showMoreInsightsHandler = () => {
    setShowMoreInsightsButton(false);
    setContentFilter("allContentLinks");
  };

  const hideInsightsHandler = () => {
    setShowMoreInsightsButton(true);
    setInsightMessage(null);
    setInsightName(null);
  };

  const likeHandler = (title) => {
    let eventkey = { event: "likecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentlikedContent.push(title);
    if (currentdislikedContent.includes(title)) {
      const index = currentdislikedContent.indexOf(title);
      currentdislikedContent.splice(index, 1);
      eventkey = { event: "likecontent-removedislike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const dislikeHandler = (title) => {
    let eventkey = { event: "dislikecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentdislikedContent.push(title);
    if (currentlikedContent.includes(title)) {
      const index = currentlikedContent.indexOf(title);
      currentlikedContent.splice(index, 1);
      eventkey = { event: "dislikecontent-removelike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeLikeHandler = (title) => {
    let eventkey = { event: "removelikecontent", value: title };
    var currentlikedContent = [...likedContent];
    const index = currentlikedContent.indexOf(title);
    currentlikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeDislikeHandler = (title) => {
    let eventkey = { event: "removedislikecontent", value: title };
    var currentdislikedContent = [...dislikedContent];
    const index = currentdislikedContent.indexOf(title);
    currentdislikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const saveHandler = (title) => {
    let eventkey = { event: "savedcontent", value: title };
    let currentSavedContent = [...savedContent];
    let metricData = userMetricsData;
    if (currentSavedContent.includes(title)) {
      const index = currentSavedContent.indexOf(title);
      currentSavedContent.splice(index, 1);
      eventkey = { event: "removeSaved", value: title };
    } else {
      currentSavedContent.push(title);
    }
    metricData["savedcontent"] = [...currentSavedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setSavedContent([...currentSavedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const shareHandler = (title) => {
    setShareContentTitle(title);
    setShareContent(true);
  };

  const getContentLinkHandler = (item) => {
    call(`content/${item.title}`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          setPlayContent(true);
          setContent(res.data);
        }
      })
      .catch((err) => {
        console.log("error is", err);
        Sentry.captureException(err);
      });
  };

  const closeContentPlayer = () => {
    setPlayContent(false);
  };

  const closeShareContentHandler = () => {
    setShareContent(false);
  };

  return (
    <DashboardLayout>
      {loader ? (
        <Dialog open={loader} fullScreen>
          <DialogContent>
            <Loader loaderText={t("loaderText.loadingInsights")} />
          </DialogContent>
        </Dialog>
      ) : insightsNotReady ? (
        <MDBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="60vh"
          textAlign="center"
          px={3}
        >
          <Icon sx={{ fontSize: "48px !important", mb: 2, color: palette.text.secondary }}>
            hourglass_top
          </Icon>
          <MDTypography variant="h5" fontWeight="bold" mb={1}>
            {t("insights.stillProcessingTitle")}
          </MDTypography>
          <MDTypography variant="body2" color="text.secondary" mb={3}>
            {t("insights.stillProcessingBody")}
          </MDTypography>
          <MDButton variant="contained" color="info" onClick={() => loadInsights(0)}>
            {t("insights.stillProcessingRetry")}
          </MDButton>
        </MDBox>
      ) : (
        <>
          <DashboardNavbar
            breadcrumbs={
              <Breadcrumbs
                icon="home"
                title={t("pageTitles.insights")}
                route={["Insights"]}
                light={false}
              />
            }
          />

          {/* Page Header */}
          <MDBox mt={3} mb={3}>
            <MDBox display="flex" alignItems="center" gap={2} flexWrap="wrap">
              <MDTypography variant="h3" fontWeight="bold">
                {t("insights.title", { learnerName })}
              </MDTypography>
              {animalName && (
                <Chip
                  avatar={<Avatar src={animalThumbnail} sx={{ width: 28, height: 28 }} />}
                  label={t("insights.animal", { animalName })}
                  variant="outlined"
                  sx={{
                    borderRadius: 10,
                    fontWeight: "bold",
                    fontSize: "0.875rem",
                    height: 36,
                    px: 0.5,
                  }}
                />
              )}
            </MDBox>
            <MDTypography variant="body2" color="secondary" mt={0.5}>
              {t("insights.basedOnLatest")}
            </MDTypography>
          </MDBox>

          {/* Personality Card */}
          <Card sx={{ mb: 3, overflow: "hidden" }}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={5}
                sx={{
                  bgcolor: palette.brand[200],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: { xs: 240, md: 440 },
                }}
              >
                {animalThumbnail ? (
                  <MDBox
                    component="img"
                    src={animalThumbnail}
                    alt={animalName}
                    sx={{ width: "100%", maxHeight: 480, objectFit: "contain", p: 2 }}
                  />
                ) : (
                  <Icon sx={{ fontSize: 80, color: "text.secondary" }}>insights</Icon>
                )}
              </Grid>

              <Grid item xs={12} md={7}>
                <MDBox
                  p={{ xs: 3, md: 4 }}
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  height="100%"
                >
                  <MDTypography variant="h4" fontWeight="bold" mb={2}>
                    {t("insights.yourPersonality")}{" "}
                    <span style={{ color: "#1565c0" }}>{t("insights.animal", { animalName })}</span>
                  </MDTypography>

                  <MDBox
                    sx={{
                      borderLeft: "4px solid #1565c0",
                      bgcolor: "#f0f4ff",
                      borderRadius: "0 8px 8px 0",
                      p: 2.5,
                      mb: 3,
                    }}
                  >
                    <MDTypography variant="body1" lineHeight={1.75}>
                      {insightSummary}
                    </MDTypography>
                  </MDBox>

                  {insightRecommendations.length > 0 && (
                    <>
                      <MDTypography variant="subtitle1" fontWeight="bold" mb={2}>
                        {t("insights.howToBringOut")}
                      </MDTypography>

                      <Grid container spacing={2}>
                        {insightRecommendations.slice(0, 4).map((rec, i) => {
                          const icon = getRecommendationIcon(rec);

                          return (
                            <Grid item xs={6} sm={4} key={i}>
                              <MDBox textAlign="center">
                                <MDBox
                                  sx={{
                                    width: 72,
                                    height: 72,
                                    borderRadius: "50%",
                                    bgcolor: TILE_BGS[i],
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mx: "auto",
                                    mb: 1.5,
                                  }}
                                >
                                  <Icon sx={{ color: TILE_COLORS[i], fontSize: 36 }}>{icon}</Icon>
                                </MDBox>

                                <MDTypography
                                  variant="body2"
                                  color="text"
                                  lineHeight={1.5}
                                  display="block"
                                >
                                  {rec}
                                </MDTypography>
                              </MDBox>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </>
                  )}
                </MDBox>
              </Grid>
            </Grid>
          </Card>

          {/* Detailed Insight Report */}
          {!showMoreInsightsButton && assessmentType === "NEO" && (
            <Grid container spacing={3} mb={3}>
              <Grid item xs={12} md={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox p={3} height="100%" display="flex" flexDirection="column">
                    <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                      <MDTypography variant="h6" fontWeight="medium">
                        {t("insights.insightChart")}
                      </MDTypography>
                      <Icon sx={{ color: "text.secondary", fontSize: 20 }}>info_outline</Icon>
                    </MDBox>

                    <MDBox sx={{ position: "relative", flex: 1 }}>
                      <Doughnut
                        data={data}
                        options={{
                          animation: { duration: 0 },
                          plugins: {
                            legend: { display: false },
                            tooltip: {
                              xAlign: "center",
                              yAlign: "bottom",
                              backgroundColor: palette.white,
                              bodyColor: palette.chart.black,
                              borderWidth: 1,
                              borderColor: palette.chart.black,
                              callbacks: {
                                label: (data) => {
                                  if (data.datasetIndex == 1) {
                                    const labelKey = data.label
                                      ? data.label.toLowerCase()
                                      : "default";
                                    return t(`insights.${labelKey}`);
                                  } else {
                                    let val = parseInt(data.dataset.scores[data.dataIndex]);
                                    if (val < 45) return t(`insights.low`);
                                    else if (val < 56) return t(`insights.medium`);
                                    else return t(`insights.high`);
                                  }
                                },
                              },
                              filter: function (tooltipItem) {
                                const { backgroundColor } = tooltipItem.dataset;
                                return (
                                  backgroundColor[tooltipItem.dataIndex] !== palette.chart.grey
                                );
                              },
                            },
                            datalabels: {
                              formatter: function (value, context) {
                                const val = context.chart.data.labels[context.dataIndex];
                                if (context.datasetIndex === 1) {
                                  if (typeof val == "string") return val.slice(0, 1);
                                } else {
                                  return "";
                                }
                              },
                              font: { weight: "bold", size: 16 },
                              color: "white",
                            },
                          },
                          onHover: (event, activeElements) => {
                            event.native.target.style.cursor =
                              activeElements?.length > 0 ? "pointer" : "auto";
                          },
                          onClick: (evt, activeEls, chart) =>
                            pieSliceHAndler(evt, activeEls, chart),
                        }}
                      />
                      <div
                        style={{
                          textAlign: "center",
                          position: "absolute",
                          top: "54%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <MDBox
                          component="img"
                          src={logo}
                          alt={t("imageAlts.maxuLogo")}
                          width="65%"
                        />
                      </div>
                    </MDBox>

                    <MDBox display="flex" flexWrap="wrap" gap={2} mt={3} justifyContent="center">
                      {insightScoreKey.map((key, i) => (
                        <MDBox key={i} display="flex" alignItems="center" gap={0.75}>
                          <MDBox
                            sx={{
                              width: 12,
                              height: 12,
                              borderRadius: "50%",
                              bgcolor: LEGEND_COLORS[i],
                              flexShrink: 0,
                            }}
                          />
                          <MDTypography variant="caption" color="text">
                            {key.slice(0, 1)} - {key}
                          </MDTypography>
                        </MDBox>
                      ))}
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox p={3} height="100%" display="flex" flexDirection="column">
                    {insightName ? (
                      <MDBox display="flex" alignItems="center" gap={1.5} mb={3}>
                        <MDBox
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            bgcolor: "#fff3e0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <Icon sx={{ color: "#e65100" }}>psychology</Icon>
                        </MDBox>
                        <MDTypography variant="h6" fontWeight="bold">
                          {t("insights.aboutTrait")} {insightName}
                        </MDTypography>
                      </MDBox>
                    ) : (
                      <MDTypography variant="h6" fontWeight="bold" mb={3}>
                        {t("insights.insightChart")}
                      </MDTypography>
                    )}

                    {insightMessage ? (
                      <MDBox component="ul" sx={{ listStyle: "none", p: 0, m: 0, flex: 1 }}>
                        {insightMessage.map((mess, index) => (
                          <InsightMessageItem key={index} message={mess} />
                        ))}
                      </MDBox>
                    ) : (
                      <MDBox
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        flex={1}
                        gap={1.5}
                      >
                        <Icon sx={{ fontSize: 56, color: "text.secondary", opacity: 0.3 }}>
                          donut_large
                        </Icon>
                        <MDTypography
                          variant="body2"
                          color="secondary"
                          textAlign="center"
                          sx={{ maxWidth: 280 }}
                        >
                          {t("insights.insightMessage")}
                        </MDTypography>
                      </MDBox>
                    )}
                  </MDBox>
                </Card>
              </Grid>

              {/* <Grid item xs={12}>
                <MDButton
                  onClick={hideInsightsHandler}
                  variant="outlined"
                  color="primary"
                  fullWidth
                >
                  {t("insights.hideInsightReport")}
                </MDButton>
              </Grid> */}
            </Grid>
          )}

          {/* Bottom CTA Banner */}
          <Card sx={{ mb: 3, bgcolor: "#f8fafc" }}>
            <MDBox
              p={3}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
              gap={2}
            >
              <MDBox display="flex" alignItems="center" gap={2}>
                <MDBox
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: 2,
                    bgcolor: "#e3f2fd",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Icon sx={{ color: "#1565c0", fontSize: 32 }}>assignment</Icon>
                </MDBox>
                <MDBox>
                  <MDTypography variant="h6" fontWeight="bold">
                    {t("insights.wantToDiveDeeperTitle")}
                  </MDTypography>
                  <MDTypography variant="body2" color="secondary">
                    {t("insights.wantToDiveDeeperBody")}
                  </MDTypography>
                </MDBox>
              </MDBox>

              <MDBox display="flex" gap={2} flexWrap="wrap">
                {userId == profile.id ? (
                  <MDButton variant="outlined" color="info" onClick={() => navigate("/mygameplan")}>
                    {t("insights.viewGamePlan")}
                  </MDButton>
                ) : (
                  <MDButton
                    variant="outlined"
                    color="info"
                    onClick={() =>
                      navigate("/contentlibrary", {
                        state: { learnerId: userId, assessmentId: assessment_id },
                      })
                    }
                  >
                    {t("insights.exploreContent")}
                  </MDButton>
                )}
                {assessmentType === "NEO" && (
                  <MDButton
                    variant="contained"
                    color="info"
                    onClick={showMoreInsightsButton ? showMoreInsightsHandler : hideInsightsHandler}
                    endIcon={<Icon>arrow_forward</Icon>}
                  >
                    {showMoreInsightsButton
                      ? t("insights.showInsightReport")
                      : t("insights.hideInsightReport")}
                  </MDButton>
                )}
              </MDBox>
            </MDBox>
          </Card>

          {/* Top Content */}
          {topContent && topContent.length > 0 && (
            <Card sx={{ mb: 3 }}>
              <MDBox p={3}>
                <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={3}>
                  <MDTypography variant="h6" fontWeight="bold">
                    {t("insights.topContentTitle")}
                  </MDTypography>

                  {/* <MDButton
                    variant="text"
                    color="info"
                    onClick={() =>
                      navigate("/contentlibrary", {
                        state: { learnerId: userId, assessmentId: assessment_id },
                      })
                    }
                    sx={{ fontSize: "0.85rem", textTransform: "none", fontWeight: "medium" }}
                    endIcon={<Icon>chevron_right</Icon>}
                  >
                    {t("insights.viewAll")}
                  </MDButton> */}

                  {userId == profile.id ? (
                    <MDButton
                      variant="text"
                      color="info"
                      onClick={() => navigate("/mygameplan")}
                      sx={{ fontSize: "0.85rem", textTransform: "none", fontWeight: "medium" }}
                      endIcon={<Icon>chevron_right</Icon>}
                    >
                      {t("insights.viewGamePlan")}
                    </MDButton>
                  ) : (
                    <MDButton
                      variant="text"
                      color="info"
                      onClick={() =>
                        navigate("/contentlibrary", {
                          state: { learnerId: userId, assessmentId: assessment_id },
                        })
                      }
                      sx={{ fontSize: "0.85rem", textTransform: "none", fontWeight: "medium" }}
                      endIcon={<Icon>chevron_right</Icon>}
                    >
                      {t("insights.viewAll")}
                    </MDButton>
                  )}
                </MDBox>

                <Grid container spacing={3}>
                  {topContent.map((item, index) => {
                    let icon = "movie";
                    const content_type = item.content_type.toLowerCase();
                    if (content_type === "video") icon = "movie";
                    else if (content_type === "infographic") icon = "leaderboard";
                    else if (content_type === "article") icon = "article";
                    else if (content_type === "worksheet") icon = "note";
                    return (
                      <Grid item xs={12} md={4} key={index}>
                        <DefaultProjectCard
                          item={item}
                          icon={icon}
                          type={item.content_type}
                          title={item.title}
                          content_url={item.content_url}
                          image={item.thumbnail_url || MaxuLogo}
                          getContentLinkHandler={getContentLinkHandler}
                          shareable={userId != profile.id}
                          liked={likedContent.includes(item.title)}
                          disliked={dislikedContent.includes(item.title)}
                          saved={savedContent.includes(item.title)}
                          viewed={viewedContent.includes(item.title)}
                          likeHandler={likeHandler}
                          dislikeHandler={dislikeHandler}
                          removeLikeHandler={removeLikeHandler}
                          removeDislikeHandler={removeDislikeHandler}
                          saveHandler={saveHandler}
                          shareHandler={shareHandler}
                          action={{
                            type: "external",
                            route: item.content_url,
                            color: "info",
                            label: t("buttonTitles.view"),
                          }}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </MDBox>
            </Card>
          )}
        </>
      )}

      {playContent && (
        <ContentPlayerDialog
          playContent={playContent}
          closeContentPlayer={closeContentPlayer}
          content={content}
          userMetricsData={userMetricsData}
          setUserMetricData={setUserMetricsData}
          setViewedContent={setViewedContent}
          userId={profile.id}
          t={t}
        />
      )}
      {shareContent && (
        <ShareContentDialog
          shareContent={shareContent}
          setShareContent={setShareContent}
          closeShareContentHandler={closeShareContentHandler}
          shareContentTitle={shareContentTitle}
          learnerMetricsData={learnerMetricsData}
          setLearnerMetricData={setLearnerMetricData}
          learnerId={userId}
          t={t}
        />
      )}
    </DashboardLayout>
  );
}

function InsightMessageItem({ message }) {
  return (
    <MDBox
      component="li"
      display="flex"
      alignItems="flex-start"
      gap={1.5}
      py={1.25}
      sx={{
        borderBottom: "1px solid rgba(0,0,0,0.06)",
        "&:last-child": { borderBottom: "none" },
      }}
    >
      <MDBox
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: "#1565c0",
          flexShrink: 0,
          mt: "6px",
        }}
      />
      <MDTypography variant="body2" color="text" lineHeight={1.65}>
        {message}
      </MDTypography>
    </MDBox>
  );
}
